var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLobbyMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27152",
    "data-name": "Group 27152",
    transform: "translate(-550 -182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13395",
    "data-name": "Rectangle 13395",
    width: 32,
    height: 32,
    transform: "translate(550 182)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "alert",
    d: "M10,20A10,10,0,1,1,20,10,10,10,0,0,1,10,20Zm0-2a8,8,0,1,0-8-8A8,8,0,0,0,10,18ZM10,5a1,1,0,0,1,1,1v5a1,1,0,0,1-2,0V6A1,1,0,0,1,10,5Zm0,10a1,1,0,1,1,1-1A1,1,0,0,1,10,15Z",
    transform: "translate(556 188)",
    fill: "#8A8A8A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobbyMessageIcon);
export default __webpack_public_path__ + "static/media/LobbyMessageIcon.5a24d57c.svg";
export { ForwardRef as ReactComponent };